import { useContext, useEffect, useState } from 'react';
import { Link} from 'react-router-dom';
import { ThemeContext } from '../../../../context/ThemeContext';
import { useGetUserDashboardQuery } from '../../../../store/services/student/SessionService';
import SessionSection from '../../../components/Dashboard/SessionSection';
import { useSelector } from 'react-redux';

const getProficiencyLabel = (level) => {
  if (level <= 1) return "Beginner";
  if (level <= 2) return "Elementary";
  if (level <= 3) return "Intermediate";
  if (level <= 4) return "Upper-Intermediate";
  if (level <= 5) return "Advanced";
  return "Unknown";
};

const StudentDashboard = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize] = useState(5);

  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

   const { data, error, isLoading } = useGetUserDashboardQuery({ pageNumber: currentPage,
    pageSize, search: searchTerm });
    console.log(data);
    const { currentUser } = useSelector((state) => state.auth);
    

  useEffect(() => {
    if (data?.data) {
      setTotalCount(data.data.length);
    }
  }, [data]);

  const proficiencyArray = data?.data || []; 
  // const averageProficiency = proficiencyArray.length > 0
  //     ? proficiencyArray.reduce((sum, item) => sum + Number(item.proficiency || 0), 0) /
  //       proficiencyArray.length : 0;
  const averageProficiency = proficiencyArray[0]?.proficiency;

  if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
  if (error) return <div className="alert alert-danger">Error loading student details.</div>;

  return (
    <>
        <div className="row align-items-center my-3">
            <div className="col-lg-6 mb-2">
                <h2 className="mb-2">Welcome back, {currentUser?.fullName}! 👋</h2>
                <p className="text-muted">Here’s a snapshot of your progress and upcoming lessons.</p>
            </div>

            <div className="col-lg-6 mb--xl-2 mb-4 text-lg-end text-start">
                <h6 className="heading mb-1">Language Proficiency Level</h6>
                 <div className="mt-2 d-inline-flex align-items-center">
                    {averageProficiency && (
                        <span className="badge bg-primary">{averageProficiency}</span>
                    )}
                </div>
            </div>
        </div>

        {/*Book Session Prompt */}
        <div className="card mt-0">
			<div className="card-body d-flex align-items-center justify-content-between flex-wrap">
				<div className="mb-3 mb-md-0">
					<h5 className="mb-2">Book a New Live Lesson</h5>
					<p className="text-muted mb-0">Ready to schedule your next session? Follow our easy booking flow.</p>
				</div>
				<Link to="/browse-tutors" className="btn btn-primary">
            Book Now
				</Link>
			</div>
		</div>

        {/* Upcoming Lessons */}
    <SessionSection title="Upcoming Lessons" data={data?.data || []}
  		totalCount={totalCount} searchPlaceholder="Search upcoming sessions..." 
			searchTerm={searchTerm} setSearchTerm={setSearchTerm} setCurrentPage={setCurrentPage}
			currentPage={currentPage} pageSize={pageSize} showStudentName={false} showLanguage = {true} showTutor={true}/>

        {/*Audio Lessons Prompt*/}
    <div className="card mt-0">
			<div className="card-body d-flex align-items-center justify-content-between flex-wrap">
				<div className="mb-3 mb-md-0">
					<h5 className="mb-2">Learn from NKENNE’s Audio Lessons</h5>
					<p className="text-muted mb-0">Access our library of audio lessons to practice anytime.</p>
				</div>
        <div className="d-flex align-items-center mt-3">
        <span className="fw-semibold me-2">Available on:</span>
        <div className="d-flex align-items-center">
          <Link to="https://apps.apple.com/us/app/nkenne-learn-african-language/id1587537473" target="_blank" rel="noopener noreferrer" className='mb-2' >
            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="40" height="40" viewBox="0 0 24 24">
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"/>
            </svg>
          </Link>
          <Link to="https://play.google.com/store/apps/details?id=com.triaxo.nkenne&hl=en&gl=US" target="_blank" rel="noopener noreferrer" className='mb-1'>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1024 1024" class="icon" version="1.1">
              <path d="M213.696 348.032c-28.16 0-51.2 23.04-51.2 51.2V604.8c0 28.096 23.04 51.2 51.2 51.2s51.2-23.04 51.2-51.2V399.168c0-28.16-23.04-51.136-51.2-51.136z" fill=""/>
              <path d="M213.696 633.6a28.8 28.8 0 0 1-28.8-28.8V399.168a28.8 28.8 0 0 1 57.6 0V604.8a28.8 28.8 0 0 1-28.8 28.8z" fill="#1FDB00"/>
              <path d="M831.68 348.032c-28.16 0-51.2 23.04-51.2 51.2V604.8c0 28.096 22.976 51.2 51.2 51.2s51.2-23.04 51.2-51.2V399.168a51.2 51.2 0 0 0-51.2-51.136z" fill=""/>
              <path d="M831.68 633.6a28.8 28.8 0 0 1-28.8-28.8V399.168a28.8 28.8 0 0 1 57.6 0V604.8a28.8 28.8 0 0 1-28.8 28.8z" fill="#1FDB00"/>
              <path d="M294.656 709.184c0 24.64 20.16 44.8 44.8 44.8h43.008v116.8c0 28.096 23.04 51.2 51.2 51.2s51.2-23.04 51.2-51.2v-116.8h81.6v116.8c0 28.096 22.976 51.2 51.2 51.2s51.2-23.04 51.2-51.2v-116.8h38.976c24.64 0 44.8-20.16 44.8-44.8V348.032H294.656v361.152z" fill=""/>
              <path d="M617.664 899.648a28.8 28.8 0 0 1-28.8-28.8v-139.2H462.464v139.2a28.8 28.8 0 0 1-57.6 0v-139.2H339.52a22.4 22.4 0 0 1-22.4-22.464V370.432h413.184v338.752a22.4 22.4 0 0 1-22.4 22.464h-61.376v139.2c0 15.808-12.992 28.8-28.864 28.8z" fill="#1FDB00"/>
              <path d="M297.92 320h451.52a225.28 225.28 0 0 0-113.28-163.456l51.712-51.712a11.328 11.328 0 0 0 0-15.808h-0.064a11.2 11.2 0 0 0-15.808 0l-52.032 52.096c-1.728 1.664-2.24 3.968-2.624 6.144A219.456 219.456 0 0 0 528.704 128h-10.048c-27.52 0-53.824 5.184-78.208 14.4-0.256-0.384-0.128-0.96-0.448-1.28l-52.096-52.096a11.2 11.2 0 0 0-15.808 15.808l47.488 47.552A225.088 225.088 0 0 0 297.92 320z m325.376-120.768a25.984 25.984 0 1 1 0 51.904 25.984 25.984 0 0 1 0-51.904z m-197.952 0a25.984 25.984 0 1 1 0 51.904 25.984 25.984 0 0 1 0-51.904z" fill=""/>
              <path d="M325.568 297.6a202.88 202.88 0 0 1 55.296-91.456 48.448 48.448 0 1 0 38.592-28.928 197.696 197.696 0 0 1 99.2-26.816h9.984c35.648 0 69.568 9.664 98.944 26.624a48.448 48.448 0 1 0 41.024 31.04c24.768 24.256 43.392 54.912 53.184 89.472H325.568z" fill="#1FDB00"/></svg>
          </Link>
        </div>
        </div>
  
				<Link to="http://link.nkenne.com" target="_blank" className="btn btn-primary">
            Explore NKENNE App
				</Link>
			</div>
		</div>
    </>
  );
};

export default StudentDashboard;